import { Action, Reducer } from 'redux';
import { AppThunkAction } from '.';
import { map, forEach, filter, orderBy } from 'lodash';
import update from 'immutability-helper';
import { UserNotification } from '../models/UserNotificationModels';
import { NotificationTypeEnum, NotificationToast } from '../models/NotificationModels'
import { ToastNotificationManager } from '../infrastructure/ToastNotificationManager'
import { ApiResponseHelper } from '../infrastructure/utils/ApiResponseHelper'
import { UserNotificationRequests } from '../apiRequests/UserNotificationRequests';
import internal from 'assert';





export interface UserNotificationState {
    isLoading: boolean;
    importantNotifications: UserNotification[];
    isExistsImportant: boolean;

}


export interface InitUserNotificationAction {
    type: 'INIT_USER_NOTIFICATION';
}

export interface UnMountUserNotificationAction {
    type: 'UNMOUNT_USER_NOTIFICATION';
}

export interface RequestImportantNotificationAction {
    type: 'REQUEST_IMPORTANT_NOTIFICATION';
}

export interface ReceiveImportantNotificationAction {
    type: 'RECEIVE_IMPORTANT_NOTIFICATION';
    importantNotifications: UserNotification[];

}

export interface ErrorImportantNotificationAction {
    type: 'ERROR_IMPORTANT_NOTIFICATION';
}


export interface AddImportantNotificationAction {
    type: 'ADD_IMPORTANT_NOTIFICATION';
    importantNotifications: UserNotification[];

}

export interface ReadImportantNotificationAction {
    type: 'READ_IMPORTANT_NOTIFICATION';
    importantNotifications: UserNotification[];

}






const apiUserNotificationRequests = new UserNotificationRequests();


type KnownAction = InitUserNotificationAction | UnMountUserNotificationAction |
    RequestImportantNotificationAction | ReceiveImportantNotificationAction | ErrorImportantNotificationAction |
    AddImportantNotificationAction | ReadImportantNotificationAction;


export const actionCreators = {

    InitUserNotificationAction: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        apiUserNotificationRequests.Init();

        dispatch({
            type: 'INIT_USER_NOTIFICATION',
        });

    },
    UnMountUserNotificationAction: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        apiUserNotificationRequests.Abort();

        dispatch({
            type: 'UNMOUNT_USER_NOTIFICATION',
        });

    },

    GetImportantNotificationAction: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        dispatch({
            type: 'REQUEST_IMPORTANT_NOTIFICATION',
        });

        let resultGetUserNotifications = await apiUserNotificationRequests.GetUserNotifications({
            take: null,
            skip: null,
            isReadInclude: false,
            isImportant: true,
            notificationTypeId: null
        });
        if (resultGetUserNotifications.result) {
            dispatch({
                type: 'RECEIVE_IMPORTANT_NOTIFICATION',
                importantNotifications: orderBy(resultGetUserNotifications.data, item => item.dateCreate)
            });

        }
        else {
            let notificationError: NotificationToast = {
                type: NotificationTypeEnum.danger,
                message: `Получение оповещений. ${ApiResponseHelper.GetErrorMessage(resultGetUserNotifications.error)}`,
                additionalMessage: ApiResponseHelper.GetErrorGuid(resultGetUserNotifications.error)
            }
            ToastNotificationManager.SendToast(notificationError);

            dispatch({ type: 'ERROR_IMPORTANT_NOTIFICATION' });
        }

    },

    AddImportantNotificationAction: (notification: UserNotification): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        let importantNotifications = getState().userNotification?.importantNotifications || [];

        if (importantNotifications.findIndex(item => item.id === notification.id) >= 0) {
            return;
        }

        let newImportantNotifications = update(importantNotifications, {
            $unshift: [notification]
        });


        dispatch({
            type: 'ADD_IMPORTANT_NOTIFICATION',
            importantNotifications: newImportantNotifications
        });
    },

    ReadImportantNotificationAction: (notificationId: string): AppThunkAction<KnownAction> => async (dispatch, getState) => {


        let importantNotifications = getState().userNotification?.importantNotifications || [];

        let notificationIndex = importantNotifications.findIndex(item => item.id === notificationId);


        let newImportantNotifications = notificationIndex >= 0
            ? update(importantNotifications, {
                $splice: [[notificationIndex, 1]]

            })
            : importantNotifications


        dispatch({
            type: 'READ_IMPORTANT_NOTIFICATION',
            importantNotifications: newImportantNotifications
        });

        await apiUserNotificationRequests.ReadUserNotification(notificationId);


    },


};


const unloadedState: UserNotificationState = {
    isLoading: false, importantNotifications: [], isExistsImportant: false
};

export const reducer: Reducer<UserNotificationState> = (state: UserNotificationState | undefined, incomingAction: Action): UserNotificationState => {
    if (state === undefined) {
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'INIT_USER_NOTIFICATION':
            return {
                ...state,
            };

        case 'UNMOUNT_USER_NOTIFICATION':
            return {
                ...unloadedState,
            };
        case 'REQUEST_IMPORTANT_NOTIFICATION':
            return {
                ...state,
                isLoading: true,
            };
        case 'RECEIVE_IMPORTANT_NOTIFICATION':
            return {
                ...state,
                isLoading: false,
                importantNotifications: action.importantNotifications,
                isExistsImportant: action.importantNotifications?.length > 0
            }
        case 'ERROR_IMPORTANT_NOTIFICATION':
            return {
                ...state,
                isLoading: false,
            };
        case 'ADD_IMPORTANT_NOTIFICATION':
            return {
                ...state,
                isLoading: false,
                importantNotifications: action.importantNotifications,
                isExistsImportant: action.importantNotifications?.length > 0
            }
        case 'READ_IMPORTANT_NOTIFICATION':
            return {
                ...state,
                isLoading: false,
                importantNotifications: action.importantNotifications,
                isExistsImportant: action.importantNotifications?.length > 0
            }
        default:
            return state;
    }

};
